import React, { useState, useEffect } from 'react';

const SplashScreen = ({ onComplete }) => {
  const [progress, setProgress] = useState(0);
  
  useEffect(() => {
    const timer = setInterval(() => {
      setProgress(prevProgress => {
        const newProgress = prevProgress + 1.5;
        if (newProgress >= 100) {
          clearInterval(timer);
          setTimeout(() => {
            if (onComplete) onComplete();
          }, 700);
          return 100;
        }
        return newProgress;
      });
    }, 70);
    
    return () => clearInterval(timer);
  }, [onComplete]);
  
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gradient-to-br from-violet-900 via-violet-800 to-black">
      <div className="flex flex-col items-center justify-center h-full w-full">
        {/* Le texte HUST plus petit (4xl au lieu de 6xl) */}
        <h1 className="text-4xl font-bold italic text-white tracking-wider mb-8">HUST</h1>
        
        {/* Barre de progression */}
        <div className="w-64 h-2 bg-gray-700/50 rounded-full overflow-hidden">
          <div 
            className="h-full bg-violet-500 rounded-full transition-all duration-300 ease-out" 
            style={{ width: `${progress}%` }}
          ></div>
        </div>
      </div>
    </div>
  );
};

export default SplashScreen;
